import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import FastTextArea from '../util/FastTextArea';
import FastFormQuestion from '../util/FastFormQuestion';
import DIALOG_FIELDS from '../../step2_questions.json';

export default function DescribeAnalyzeDialog(props) {

    const handleClose = () => {
        props.handleCloseDialog()
    }
    const handleCancel = () => {
        props.handleCancelDialog()
    }

    const isPreviousStepComplete = (programId) => {
        if (programId) {
            if (props.step1CompletionData[programId] &&
                props.step1CompletionData[programId].completed) {
                return true
            }
        }
        return false
    }

    const isFormDisabled = (programId) => {
        if (programId) {
            if (!props.step1CompletionData[programId] ||
                !props.step1CompletionData[programId].completed) {
                return true
            }

            if (props.stepCompletionData && programId in props.stepCompletionData) {
                return props.stepCompletionData[programId]?.completed
            } else {
                // no completion data found for programId
                // indicating step is incomplete
                // Allow user to complete form.
                return false
            }
        }
        return true
    }
    
    return (
        <Modal size="lg" show={props.showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Assessment Tool - Edit</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-center">
                    <h2>Assessment Tool</h2>
                    <div className="p-3">
                    Use the boxes below to describe the assessment tool 
                    that will be used to assess each outcome.
                    </div>
                    { !isPreviousStepComplete(props.selectedProgram?.programId) 
                        ? <div className="pb-3">
                            <span className="text-danger">
                                Previous step(s) must be completed before this step can be completed.
                            </span>
                          </div>
                        : <></>
                    }
                </div>
                <div className="mx-5">
                    <Form onSubmit={props.onSave}>
                        <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                Department
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    {props.department.name}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                Program
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    {props.selectedProgram?.name}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                Theme
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    {props.theme ? props.theme.name : 'Unavailable'}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                Learning Outcome
                            </Form.Label>
                            <Col sm="8">
                                <Form.Select 
                                    aria-label="Select Learning Outcome"
                                    onChange={props.handleLearningOutcomeChanged}
                                    name={'program-' + props.selectedProgram?.programId + '_slo-' + props.selectedLearningOutcome?.sloId}
                                    value={props.selectedLearningOutcome?.sloId}
                                    >
                                    { props.selectedProgram &&
                                        props.learningOutcomes[props.selectedProgram.programId].map((slo, key) =>
                                            <option key={key} value={slo.sloId}>{slo.text}</option>
                                        )
                                    }
                                </Form.Select>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                Focus Area
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    { props.selectedProgram &&
                                        props.step1DataStore[props.selectedProgram?.programId][props.selectedLearningOutcome?.sloId]?.s1q1}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                <FastFormQuestion 
                                    text={DIALOG_FIELDS["toolDescription"].text}
                                    required={DIALOG_FIELDS["toolDescription"].required}
                                    />
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="toolDescription"
                                    callback={props.onToolDescriptionChanged}
                                    text={props.analysisData.toolDescription}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="512"
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                {DIALOG_FIELDS["coursesAssessed"].text}
                                {
                                    DIALOG_FIELDS["coursesAssessed"].required ?
                                    <span className="ps-1 text-danger fw-bold">*</span>
                                    :
                                    <></>
                                }
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="coursesAssessed"
                                    callback={props.onCoursesAssessedChanged}
                                    text={props.analysisData.coursesAssessed}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="512"
                                    />
                            </Col>
                        </Form.Group>
                                
                        <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                {DIALOG_FIELDS["brightspaceAutomation"].text}
                                {
                                    DIALOG_FIELDS["brightspaceAutomation"].required ?
                                    <span className="ps-1 text-danger fw-bold">*</span>
                                    :
                                    <></>
                                }
                            </Form.Label>
                            <Col sm="8">
                                <Form.Select 
                                    name="brightspaceAutomation"
                                    aria-label="Brightspace automated data collection?"
                                    value={props.analysisData.brightspaceAutomation}
                                    onChange={props.onBrightspaceAutomationChanged}
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    >
                                    <option></option>
                                    <option value='yes'>Yes</option>
                                    <option value='no'>No</option>
                                    <option value='maybe'>Maybe</option>
                                </Form.Select>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1">
                            <Form.Label column sm="4">
                                <FastFormQuestion 
                                    text={DIALOG_FIELDS["hypotheticalAnalysis"].text}
                                    required={DIALOG_FIELDS["hypotheticalAnalysis"].required}
                                    />
                                <span className="text-muted">
                                    Examples: <a href="https://rise.articulate.com/share/8PlCRlz2thD7iLcdfRdjiQfYfS08LBWq" target="_blank">View</a>
                                </span>
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="hypotheticalAnalysis"
                                    callback={props.onHypotheticalAnalysisChanged}
                                    text={props.analysisData.hypotheticalAnalysis}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="1024"
                                    />
                            </Col>
                        </Form.Group>
                    </Form>
                    <div className="text-center">
                        <span className="pe-1 text-danger fw-bold">*</span>
                        <span>Indicates required field</span>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ display: "flex", justifyContent: "center"}}>
                <Button
                    variant="secondary"
                    onClick={handleCancel}
                    className="p-25"
                    >
                    Cancel
                </Button>
                <Button 
                    variant="primary"
                    onClick={handleClose}
                    className="p-25"
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
